import {
    APPBAR_HEIGHT,
    IconButton as UiIconButton,
    Backdrop as MuiBackdrop,
    styled,
} from "@l2r-front/l2r-ui"

import { ADDITIONAL_SIDEBAR_WIDTH } from "../../../../common/constants/layout"

import { VerticalSignFilters as L2rVerticalSignFilters } from "../VerticalSignFilters"
import { VerticalSignTypeList as L2RVerticalSignTypeList } from "../VerticalSignTypeList"

export const SIDEBAR_SPACING = 8
export const SIDEBAR_SPACING_MOBILE = 4

export const Container = styled("div")(() => ({
}))

export const VerticalSignTypeList = styled(L2RVerticalSignTypeList)(({ theme }) => ({
    padding: theme.spacing(8),
}))

export const AdditionalSidebar = styled("div")(({ index }) => ({
    height: `calc(100% - ${APPBAR_HEIGHT}px)`,
    position: "fixed",
    left: `calc(500px + ${index * ADDITIONAL_SIDEBAR_WIDTH}px)`,
    top: APPBAR_HEIGHT,
    width: ADDITIONAL_SIDEBAR_WIDTH,
    overflowY: "auto",
}))

export const TitleSideComponentWrapper = styled("div")({
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
})

export const IconButton = styled(UiIconButton)(() => ({
    marginLeft: "auto",
}))

export const VerticalSignFilters = styled(L2rVerticalSignFilters)(({ theme }) => ({
    backgroundColor: theme.palette["common/white_states"].main,
    boxShadow: theme.customShadow("LCS/Shadow-simple"),
    left: 0,
    position: "absolute",
    right: 0,
    zIndex: theme.zIndex.appBar + 1,
}))

export const TagsFilterListWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 0, 2, 0),
}))

export const VerticalSigningDetailSidebarContainer = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 8, 6, 8),
}))

export const BackdropFilter = styled(MuiBackdrop)(({ theme }) => ({
    backgroundColor: "transparent",
    cursor: "pointer",
    zIndex: theme.zIndex.mobileStepper,
}))